module.exports = __webpack_public_path__ + "static/media/raise.33fb246c.mp3";